import { CreateJobValues } from "./../../pages/job/create/index";
import { useNavigate } from "react-router-dom";

// This hooks takes care of deciphering slugs and providing id and slug from params
function useNavigateCreateJob() {
  const navigate = useNavigate();

  const goToCreateJobs = (state: { default: Partial<CreateJobValues> }) => {
    navigate("/job/create", { state });
  };

  return { goToCreateJobs };
}

export default useNavigateCreateJob;
